/**
 * Cosmetic display names for skin conditions.
 * Maps backend/API class_name to user-facing labels (matches backend skin_config.json display_name).
 * Use for radar labels, insight cards, condition description headers, and routine page.
 */
export const CONDITION_DISPLAY_NAMES = {
  'Wrinkles': 'Fine Lines',
  'Dry skin': 'Oily Skin',
  'Oily skin': 'Oily Skin',
  'Dark circle': 'Under-Eye',
  'Acne': 'Breakouts',
  'Red spot': 'Skin Redness',
  'Pigmentation': 'Pigmentation',
  'Dark spots': 'Dark Spots',
  'Whiteheads': 'White Bumps',
  "Crow's feet": 'Eye Lines',
  'Open Pores': 'Visible Pores',
  'Blackheads': 'Black Bumps',
  'Clogged Pores': 'Pore Buildup',
  'Eye Bags': 'Under-Eye Puffiness',
  'Unknown': 'Other',
  'Mole': 'Skin Spot',
  'Normal skin': 'Normal Skin',
  // Segmentation/score conditions (keep as-is or alias)
  'Hydration': 'Hydration',
  'Oxygen': 'Oxygen',
  'Smoothness': 'Smoothness',
  'Dullness': 'Dullness',
  'UnevenSkin': 'UnevenSkin',
  'Uneven Skintone': 'UnevenSkin',
  'Uneven Skin': 'UnevenSkin'
};

/**
 * Get the cosmetic display name for a condition (backend class_name or condition key).
 * @param {string} conditionKey - Backend class_name or condition key
 * @returns {string} Display name for UI
 */
export const getConditionDisplayName = (conditionKey) => {
  if (!conditionKey) return 'Other';
  return CONDITION_DISPLAY_NAMES[conditionKey] || conditionKey;
};
